import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useSmsRegistrationComplete = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { accessToken, isFidoRegistered, isActivation } = state ?? {};

  useEffect(() => {
    if (isActivation) return;
    if (!accessToken) return navigateToPage(PageRoutes.LOGIN);
  }, [accessToken, isActivation]);

  const handleSmsRegistrationComplete = useCallback(() => {
    if (isActivation) {
      return navigateToPage(PageRoutes.LOGIN);
    }

    if (isFidoRegistered || !browserSupportsWebAuthn()) {
      dispatch(authActions.setIsLoggedIn(true));

      LocalStorageManager.Instance.saveObject(
        AppConfig.Instance.LocalStorageKey["accessToken"],
        accessToken,
      );
    } else navigateToPage(PageRoutes.EASY_LOGIN, false, { accessToken });
  }, []);

  return { isActivation, handleSmsRegistrationComplete };
};
